'use strict';

var _themeSections = require('@shopify/theme-sections');

var _functional = require('../utils/functional');

var _utils = require('../utils');

var selectors = {
  container: '[data-faqs]',
  item: '[data-faqs-item]',
  question: '[data-faqs-question]',
  answer: '[data-faqs-answer]'
}; /**
    * FAQs Template Script
    * ------------------------------------------------------------------------------
    * A file that contains scripts highly couple code to the FAQs section.
    *
    * @namespace faqs
    */

(0, _themeSections.register)('faqs', {
  onLoad: function onLoad() {
    var _this = this;
    var elements = {
      container: (0, _functional.getElement)(selectors.container)
    };

    this.options = {
      startClosed: elements.container.dataset.faqsClosed === 'true',
      openOneAtATime: elements.container.dataset.faqsOneAtATime === 'true'
    };
    this.faqs = (0, _functional.getElements)(selectors.item).map(function (el) {
      return {
        els: {
          el: el,
          question: (0, _functional.getElement)(selectors.question, { context: el }),
          answer: (0, _functional.getElement)(selectors.answer, { context: el })
        },
        _isOpen: el.getAttribute('aria-expanded') === 'true',
        get isOpen() {
          return this._isOpen;
        },
        set isOpen(val) {
          var _this2 = this;

          this._isOpen = val;

          if (val) {
            this.els.el.setAttribute('aria-expanded', String(val));
            (0, _utils.slideDown)(this.els.answer, _this.getAnswerHeight(this.els.answer));

            if (_this.options.openOneAtATime === true) {
              _this.faqs.filter(function (faq) {
                return faq.els.el !== _this2.els.el;
              }).forEach(function (faq) {
                return faq.isOpen = false;
              });
            }
          } else {
            (0, _utils.slideUp)(this.els.answer, _this.getAnswerHeight(this.els.answer)).then(function () {
              _this2.els.el.setAttribute('aria-expanded', String(val));
              _this2.els.answer.removeAttribute('style');
            });
          }
        }
      };
    });

    this.setupListeners();
  },
  setupListeners: function setupListeners() {
    this.faqs.forEach(function (faq) {
      faq.els.question.addEventListener('click', function () {
        return faq.isOpen = !faq.isOpen;
      });
    });
  },
  getAnswerHeight: function getAnswerHeight(el) {
    el.style.display = 'block';
    var style = window.getComputedStyle(el);
    var height = el.offsetHeight + (0, _functional.styleToNumber)(style.marginTop) + (0, _functional.styleToNumber)(style.marginBottom);
    el.style.display = '';

    return height;
  }
});